'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import SvgChevronright from '@common/icon/SvgChevronright';
import SvgModalclose from '@common/icon/SvgModalclose';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { BREAKPOINTS, ROUTES } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { AFFILIATE_APP_STORE_NOTICE_LINES } from '../_utils/resolveAffiliateClick';
export interface AffiliateGuideSheetProps {
  merchantCode: string;
  merchantName: string;
  logoImageUrl: string;
  modalText?: string | null;
  showDetailLink: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}
export const AffiliateGuideSheet = t0 => {
  const $ = _c(51);
  const {
    merchantCode,
    merchantName,
    logoImageUrl,
    modalText,
    showDetailLink,
    onConfirm,
    onClose
  } = t0;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const guideLines = isDesktop ? AFFILIATE_APP_STORE_NOTICE_LINES.desktop : AFFILIATE_APP_STORE_NOTICE_LINES.mobile;
  const t1 = isDesktop ? "gap-32" : "gap-16 pb-12 pt-20";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex flex-col", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== logoImageUrl) {
    t3 = <Image src={logoImageUrl} alt="" width={90} height={90} className="size-90 rounded-xlarge object-cover" />;
    $[2] = logoImageUrl;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isDesktop ? "gap-12" : "gap-4";
  let t5;
  if ($[4] !== t4) {
    t5 = cn("flex flex-col items-start", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = isDesktop ? "font-800 typo-h5" : "font-700 typo-body1";
  let t7;
  if ($[6] !== t6) {
    t7 = cn("flex-1 text-Gray-900", t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== merchantName || $[9] !== t7) {
    t8 = <h2 className={t7}>{merchantName} 앱에서 이어서 진행할게요!</h2>;
    $[8] = merchantName;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isDesktop || $[12] !== onClose) {
    t9 = isDesktop ? <button aria-label={"\uB2EB\uAE30"} onClick={onClose} className={cn("shrink-0 rounded-pill transition-opacity hover:opacity-80 active:opacity-60", FOCUS_RING)}><SvgModalclose originalFill={true} className="size-32" /></button> : null;
    $[11] = isDesktop;
    $[12] = onClose;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <div className="flex w-full items-center gap-24">{t8}{t9}</div>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== modalText) {
    t11 = modalText ? <p className="font-600 text-Gray-800 typo-caption1">{modalText}</p> : null;
    $[17] = modalText;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== merchantCode || $[20] !== showDetailLink) {
    t12 = showDetailLink ? <CustomLink href={ROUTES.BENEFIT_MERCHANT_DETAIL.withSearchParams({
      dynamicPath: {
        merchantCode
      }
    })} className={cn("group -mx-4 flex items-center gap-4 rounded-xxsmall px-4 font-500 tracking-[-0.28px] text-Gray-600 transition-colors typo-body4", "hover:text-Gray-800 active:text-Gray-900", FOCUS_RING)}>자세히보기<SvgChevronright className="size-15 transition group-hover:translate-x-1 group-focus-visible:translate-x-1" /></CustomLink> : null;
    $[19] = merchantCode;
    $[20] = showDetailLink;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t5) {
    t13 = <div className={t5}>{t10}{t11}{t12}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t5;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <h3 className="font-700 text-Gray-900 typo-body3">이렇게 하면 적립돼요</h3>;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== guideLines) {
    t15 = guideLines.map(_temp);
    $[28] = guideLines;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15) {
    t16 = <div className="flex flex-col gap-12">{t14}<ul className="flex flex-col gap-12 font-500 leading-[1.4] tracking-[-0.28px] text-Gray-700 typo-body4">{t15}</ul></div>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  const t17 = !isDesktop && "mt-16";
  let t18;
  if ($[32] !== t17) {
    t18 = cn("flex gap-8", t17);
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  const t19 = isDesktop ? "sub-fill" : "sub-line";
  const t20 = isDesktop ? "flex-1" : "w-109";
  let t21;
  if ($[34] !== onClose || $[35] !== t19 || $[36] !== t20) {
    t21 = <Button theme={t19} className={t20} onClick={onClose}>취소</Button>;
    $[34] = onClose;
    $[35] = t19;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  const t22 = isDesktop ? "\uC774\uB3D9\uD558\uAE30" : "\uD655\uC778\uD558\uACE0 \uC774\uB3D9";
  let t23;
  if ($[38] !== onConfirm || $[39] !== t22) {
    t23 = <Button className="flex-1" onClick={onConfirm}>{t22}</Button>;
    $[38] = onConfirm;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t18 || $[42] !== t21 || $[43] !== t23) {
    t24 = <div className={t18}>{t21}{t23}</div>;
    $[41] = t18;
    $[42] = t21;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t13 || $[46] !== t16 || $[47] !== t2 || $[48] !== t24 || $[49] !== t3) {
    t25 = <div className={t2}>{t3}{t13}{t16}{t24}</div>;
    $[45] = t13;
    $[46] = t16;
    $[47] = t2;
    $[48] = t24;
    $[49] = t3;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  return t25;
};
function _temp(line) {
  return <li key={line} className="flex items-start gap-8"><span aria-hidden={true} className="mt-8 size-3 shrink-0 rounded-pill bg-Gray-500" />{line}</li>;
}